import React from 'react';

export default function StarRating({value=0, size=14}) {
  const stars = [];
  const full = Math.floor(value);
  const half = value - full >= 0.5;
  for (let i=0;i<full;i++) stars.push('full');
  if (half) stars.push('half');
  while (stars.length < 5) stars.push('empty');

  const starStyle = { width: size, height: size, display:'inline-block', marginRight:4 };
  return (
    <div aria-label={`Rating ${value} out of 5`} style={{display:'inline-flex', alignItems:'center'}}>
      {stars.map((s,i)=>(
        <svg key={i} viewBox="0 0 24 24" style={starStyle} aria-hidden>
          <defs>
            <linearGradient id={`g-${i}`}>
              <stop offset={ s === 'full' ? '100%' : s === 'half' ? '50%' : '0%' } stopColor="#FFD166" />
              <stop offset="0%" stopColor="transparent" />
            </linearGradient>
          </defs>
          <path fill={ s === 'empty' ? 'rgba(255,255,255,0.08)' : 'url(#g-'+i+')' } d="M12 .587l3.668 7.431 8.2 1.192-5.934 5.788 1.402 8.175L12 18.896l-7.336 3.877 1.402-8.175L.132 9.21l8.2-1.192z"/>
        </svg>
      ))}
      <span className='starRatingValue' style={{marginLeft:6,color:'var(--muted)', fontSize:13}}>{value.toFixed(1)}</span>
    </div>
  );
}
